export default {
      id: "legend-usage",
      viewBox: "0 0 334 134",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#legend-usage",
      toString: function () {
        return this.url;
      }
    }